import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GuaranteComponent } from '../guarante/guarante.component';
import { ShipmentComponent } from '../shipment/shipment.component';
import { UserManagementComponent } from '../user-management/user-management.component';
import { AdminComponent } from './admin.component';

const routes: Routes = [
  {
    path: '', component: AdminComponent, 
    children: [

      { path: 'userManagement', component: UserManagementComponent, data:{title:"userManagement"} },
      { path: 'shipments', component: ShipmentComponent, data:{title:"Shipments"}  },
      { path: 'guarantee', component: GuaranteComponent, data:{title:"Guarantee"}  }

    ]

  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
